import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { APIData, PopupData, Service } from 'webapp-types';

import FormTextareaComponent from 'webapp/components/form/textarea';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class BillingPopupInvoiceMemoComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('account') declare accountService: Service.Account;
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('request') declare requestService: Service.Request;

	@tracked model: APIData.Account.AccountUpdate | null = null;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.model = this.accountService.accountObject;
	}

	@action
	save(): void {
		if (!this.model) {
			return;
		}

		this.submitInProgress = true;
		const layer = this.infolayerService.loading('Saving invoice memo...');

		this.accountService
			.updateAccountDataToBE(this.model)
			.then(
				() => {
					layer.ok('Invoice memo saved!');
					this.close();
				},
				(errorData) => {
					layer.close();
					throw errorData;
				},
			)
			.finally(() => {
				this.submitInProgress = false;
			})
			.catch(this.requestService.showAllValidationErrors.bind(this.requestService));
	}
	<template>
		<div class="title">Add invoice memo</div>
		<div class="content">
			<FormTextareaComponent
				name="invoice_memo"
				disabled={{this.submitInProgress}}
				maxlength="160"
				@value={{this.model.invoiceMemo}}
				@hideFloatLabel={{true}}
				placeholder="max 160 characters"
			/>
			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Cancel"
						@theme="grey-empty"
						@noDelay={{true}}
						@onTrigger={{this.close}}
					/>
					<SubmitButtonComponent
						@text="Save"
						@extraClass="save"
						@onTrigger={{this.save}}
						@submitInProgress={{this.submitInProgress}}
					/>
				</div>
			</div>
		</div>
	</template>
}
